import {FormControl, FormGroup} from '@angular/forms';
import {FundOrderBuyComponentControls, FundOrderBuyControlsInterface} from 'appAssets/descriptors';
import {BaseValidationFrom} from '../base-validation.form';

export class FundOrderBuyForm extends BaseValidationFrom<FundOrderBuyControlsInterface> {
    initForm(): void {
        this.form = new FormGroup({});
        this.controls = FundOrderBuyComponentControls();

        Object.keys(this.controls).forEach((key: string) => {
            const control = this.controls[key];
            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }
}
